import { useDataContext } from "../contexts";
import Panel from "./Panel";

export default function Balance({ user }) {
  const { getMemberUserById } = useDataContext();
  const selectedUser = user ? getMemberUserById(user.id) : null;

  return (
    <Panel left="Balance">
      {user && selectedUser ? (
        <div className="text-2xl font-bold text-gray-500">
          £{selectedUser.totalTransactions.toFixed(2) || "0.00"}
        </div>
      ) : (
        <div className="p-4 text-center text-gray-500">
          No user data available
        </div>
      )}
    </Panel>
  );
}
